/** P3 KPI + verification 카드. */
import { LossKpis, VerificationBlock } from '../../services/lossStructureApi';

const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

interface Props {
  kpis: LossKpis;
  verification: VerificationBlock;
}

export default function LossKpiCards({ kpis, verification }: Props) {
  return (
    <section className="loss-kpi-grid">
      <KpiCard
        title="완료 거래"
        value={`${kpis.trade_count}건`}
        sub={`승률 (실현) ${kpis.win_rate_realized.toFixed(1)}% · zeros ${kpis.zeros}`}
        tone="neutral"
      />
      <KpiCard
        title="실현 손익"
        value={money.format(kpis.realized_pl)}
        sub={`승 ${kpis.wins} · 패 ${kpis.losses}`}
        tone={kpis.realized_pl >= 0 ? 'good' : 'bad'}
      />
      <KpiCard
        title="미실현 손익"
        value={money.format(kpis.unrealized_pl)}
        sub="현재 열린 포지션 합계"
        tone={kpis.unrealized_pl >= 0 ? 'good' : 'bad'}
      />
      <KpiCard
        title="손익비"
        value={kpis.risk_reward_ratio != null ? `${kpis.risk_reward_ratio.toFixed(2)} : 1` : '데이터 없음'}
        sub="TP 평균 / |SL 평균|"
        tone="neutral"
      />
      <VerifyBadge label="V1 BUY DecisionRecord" item={verification.v1_buy_decision_records} />
      <VerifyBadge label="V2 STRATEGY_SELL profit" item={verification.v2_strategy_sell_profit_amount} />
    </section>
  );
}

function KpiCard({ title, value, sub, tone }: { title: string; value: string; sub?: string; tone: 'good' | 'bad' | 'neutral' }) {
  return (
    <article className={`loss-kpi-card loss-tone-${tone}`}>
      <span className="loss-kpi-title">{title}</span>
      <strong className="loss-kpi-value">{value}</strong>
      {sub && <span className="loss-kpi-sub">{sub}</span>}
    </article>
  );
}

function VerifyBadge({ label, item }: { label: string; item: { verified: boolean; note: string } }) {
  return (
    <article className={`loss-kpi-card loss-verify-badge ${item.verified ? 'verified' : 'pending'}`}>
      <span className="loss-verify-label">{label}</span>
      <span className="loss-verify-status">{item.verified ? '검증 완료' : '검증 중'}</span>
      <span className="loss-verify-note">{item.note}</span>
    </article>
  );
}
